let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iwWXu")).then(() => parcelRequire('4Qx3O'));